import { Icon, IconsEnum } from 'components/Icons';
import React, { useEffect, useState } from 'react';

import { AccordionBase } from 'components/simpleAccordion/SimpleAccordion';
import { IppicaNavCorsaBox } from '../ippicaNavCorsaBox';
import { IppicaNazioneCorsaDto } from 'types/swagger';
import { retriveStatoScommessaByKey } from 'features/ippica/functions';
import styles from './IppicaNavAccordion.module.scss';
import { useInternalSession } from 'hooks/useInternalSession';

export type IppicaNavAccordionProps = AccordionBase & {
  text: string;
  corse?: Array<IppicaNazioneCorsaDto>;
  // title: string;
  // iconSrc?: string;
  codiceProgramma: number;
};

export const IppicaNavAccordion = ({ text, corse, codiceProgramma, isOpen, onToggle }: IppicaNavAccordionProps) => {
  const { isAuthenticated } = useInternalSession();
  const [open, setOpen] = useState<boolean>(false);
  const [isClicked, setIsClicked] = useState<boolean>(false);

  const onAccordionOpenHandler = (): void => {
    const nextOpen = open ? false : true;
    if (onToggle) {
      onToggle(nextOpen);
    } else {
      setOpen(nextOpen);
    }
  };

  useEffect(() => {
    setOpen(isOpen ? true : false);
  }, [isOpen]);

  // This arrangement can be altered based on how we want the date's format to appear.
  let in2days = false;
  if (!!corse) {
    let currentDate = new Date().toJSON().split('T');
    let lastRaceTime = corse[corse.length - 1].dataOraAvvenimento;
    in2days = !lastRaceTime.startsWith(currentDate[0]);
  }

  const renderStatoCorsa = (corsa: IppicaNazioneCorsaDto, index: string | number, delta: number | null) => {
    const datePartenza = new Date(corsa.dataOraAvvenimento);
    const render = (
      <React.Fragment key={corsa.numeroAvvenimento + '_' + index}>
        <IppicaNavCorsaBox
          isTot={corsa.isTot}
          isTqq={corsa.isTqq}
          stato={retriveStatoScommessaByKey(corsa.codiceStatoAvvenimento)}
          isTris={corsa.isTris}
          numeroCorsa={corsa.numeroCorsa}
          orarioPartenza={datePartenza}
          codiceProgramma={codiceProgramma}
          numeroAvvenimento={corsa.numeroAvvenimento}
        />
      </React.Fragment>
    );

    if (delta == null) return render;
    if (datePartenza.getDate() == new Date().getDate() + delta) return render;
    return;
  };

  return (
    <div className={styles.item}>
      <div className={styles.triggerWrapper}>
        {/* TODO ADD IN FUTURE */}
        {/* {isAuthenticated && (
          <button type="button" className={styles.button} onClick={() => setIsClicked(!isClicked)}>
            <Icon
              color={isClicked ? 'var(--color-primary)' : 'var(--color-on-bg-primary)'}
              iconId={isClicked ? IconsEnum.FULL_PIN : IconsEnum.PIN}
              className={styles.iconPin}
            />
          </button>
        )} */}
        <button type="button" className={styles.triggerBtn} onClick={onAccordionOpenHandler}>
          {corse && (
            <Icon
              color="var(--color-on-bg-primary)"
              iconId={IconsEnum[`${corse[0].tipoGara?.toUpperCase()}`]}
              className={styles.iconTipoGara}
            />
          )}
          <p className={styles.text}>{text}</p>
          <Icon
            color="var(--color-on-bg-primary)"
            iconId={open ? IconsEnum.MINUS : IconsEnum.PLUS}
            className={styles.icon}
          />
        </button>
      </div>
      <div className={`${styles.contentWrapper} ${open ? styles.visible : ''}`}>
        {in2days ? (
          <div>
            <div className={styles.list}>
              <span className={styles.todayTomorrowText}>OGGI</span>
            </div>
            <div className={styles.list}>
              {corse?.map((corsa, index) => {
                return renderStatoCorsa(corsa, index, 0);
              })}
            </div>
            <div className={styles.list}>
              <span className={styles.todayTomorrowText}>DOMANI</span>
            </div>
            <div className={styles.list}>
              {corse?.map((corsa, index) => {
                return renderStatoCorsa(corsa, index, 1);
              })}
            </div>
          </div>
        ) : (
          <div className={styles.list}>
            {corse?.map((corsa, index) => {
              return renderStatoCorsa(corsa, index, null);
            })}
          </div>
        )}
      </div>
    </div>
  );
};
